(function () {
    'use strict';

    run.parts.darkMode = function() {
        document.getElementById('rackoot__darkmode').addEventListener('change', function(e) {
            const checked = this.checked;
            // window.localStorage.setItem('rackoot__darkmode', checked);
            setCookie('rackoot__darkmode', checked, 180);
            if (checked) {
                darkModeEnable();
            } else {
                DarkReader.disable();
            }
        });

        function darkModeEnable()
        {
            DarkReader.setFetchMethod(window.fetch);
            DarkReader.enable({
                brightness: 100,
                contrast: 90,
                sepia: 10
            });
        }
        
        const darkModeStatus = readCookie('rackoot__darkmode');
        // const darkModeStatus = window.localStorage.getItem('rackoot__darkmode');
        if (darkModeStatus == 'true') {
            darkModeEnable();
        }
    };
})();
